import React from "react"
import PropTypes from "prop-types"
// import { useStaticQuery, graphql } from "gatsby"

import Footer from "./footer"
import Header from "./header"

const Layout = ({ children, hedClassName }) => {
  return (
    <>
      <Header hedClassName={hedClassName} />
        <main>{children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout;
